import React, { useState, useEffect } from "react";
// import ScanIcon from './../assets/scan_emoji.png';
import FooterLogo from "./../assets/nexus_logo.webp";
import { HEADER_COLOR, PRIMARY_COLOR } from "../constants/theme";

import { HiEye, HiEyeOff } from "react-icons/hi";
import { useNavigate } from "react-router";
import { toast } from "react-toastify";

const ForgotPasswordOTP = () => {
  const [forgotPasswordOtp, setForgotPasswordOtp] = useState({
    otp: "",
    password: "",
    confirmPassword: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [screenWidth, setScreenWidth] = useState(0);

  const navigate = useNavigate();

  useEffect(() => {
    const resizeWindow = () => {
      setScreenWidth(window?.outerWidth);
    };

    window?.addEventListener("resize", resizeWindow);

    resizeWindow();

    return () => {
      window.removeEventListener("resize", resizeWindow);
    };
  }, []);

  const handleSubmit = async () => {
    if (
      !forgotPasswordOtp?.otp &&
      !forgotPasswordOtp?.password &&
      !forgotPasswordOtp?.confirmPassword
    ) {
      toast.error("Kindly fill all fields!");
      return;
    }

    if (!forgotPasswordOtp?.otp) {
      toast.error("OTP is required!");
      return;
    }

    if (!forgotPasswordOtp?.password) {
      toast.error("Password is required!");
      return;
    }

    if (!forgotPasswordOtp?.confirmPassword) {
      toast.error("Confirm Password is required!");
      return;
    }

    if (forgotPasswordOtp?.password !== forgotPasswordOtp?.confirmPassword) {
      toast.error("Passwords don't match!");
      return;
    }

    toast.success("Password changed!");
    navigate("/login");
  };

  return (
    <div
      className="container-fluid p-0 position-relative"
      style={{
        overflow: "hidden",
        backgroundColor: "#fae5ff",
      }}
    >
      <div
        className=""
        style={{
          position: "absolute",
          left: "50%",
          top: "0",
          height: "605px",
          width: "165vw",
          borderRadius: "50%",
          transform: "translateX(-50%) translateY(-460px)",
          backgroundColor: "rgb(203, 108, 230)",
          zIndex: "0",
        }}
      ></div>

      <div
        className="d-flex flex-column justify-content-evenly align-items-center"
        style={{
          minHeight: "145px",
          paddingBottom: "18px",
          position: "absolute",
          top: "0",
          left: "0",
          width: "100%",
          // paddingTop: '15px'
        }}
      >
        <div
          className=""
          style={{
            color: "#fae5ff",
            fontSize: "38px",
            fontWeight: "600",
          }}
        >
          SmileApp
        </div>
      </div>

      <div
        className="row w-100 mx-auto flex-column justify-content-between align-items-center position-relative"
        style={{
          minHeight: "100dvh",
          // backgroundColor: '#fae5ff'
        }}
      >
        <div
          className="col-12 p-0"
          style={{
            height: "65.5px",
          }}
        ></div>

        <div className="col-12 p-0">
          <div
            className="row w-100 h-100 mx-auto flex-column align-items-center justify-content-center"
            style={{
              // minHeight: '55vh',
              gap: "25px",
              paddingTop: "70px",
              // paddingTop: '100px'
            }}
          >
            <div className="col-12 p-0">
              <div
                className="text-center"
                style={{
                  fontSize: "24px",
                  color: HEADER_COLOR,
                  fontWeight: "600",
                  marginBottom: "10px",
                }}
              >
                OTP Verification
              </div>

              <div
                className="row w-100 flex-column mx-auto align-items-center justify-content-center"
                style={{
                  gap: "6px",
                  maxWidth: screenWidth >= 576 ? "310px" : "250px",
                }}
              >
                <div className="col-12 p-0">
                  <div className="d-flex flex-column align-items-start justify-content-center">
                    <label
                      for="forgotPasswordEmail"
                      className="text-start form-label"
                      style={{
                        fontSize: "13.5px",
                        marginLeft: "4px",
                        marginBottom: "3px",
                        fontWeight: "500",
                        color: PRIMARY_COLOR,
                      }}
                    >
                      OTP Code
                    </label>

                    <input
                      className="w-100 login-input text-start"
                      id="forgotPasswordEmail"
                      type="text"
                      placeholder=""
                      style={{
                        border: "2px solid rgb(203, 108, 230)",
                        borderRadius: "10px",
                        padding: "8px 12px",
                        backgroundColor: "rgb(255,255,255)",
                        outline: "none",
                        // width: '250px',
                        fontWeight: "400",
                        color: HEADER_COLOR,
                        letterSpacing: "0.01ch",
                        fontSize: "13.5px",
                      }}
                      value={forgotPasswordOtp?.otp}
                      onChange={(e) =>
                        setForgotPasswordOtp((prev) => {
                          return {
                            ...prev,
                            otp: e.target.value,
                          };
                        })
                      }
                    />
                  </div>
                </div>

                <div className="col-12 p-0">
                  <div className="d-flex flex-column align-items-start justify-content-center">
                    <label
                      for="forgotPasswordEmail"
                      className="text-start form-label"
                      style={{
                        fontSize: "13.5px",
                        marginLeft: "4px",
                        marginBottom: "3px",
                        fontWeight: "500",
                        color: PRIMARY_COLOR,
                      }}
                    >
                      Password
                    </label>

                    <div
                      className="w-100 position-relative d-flex align-items-center"
                      style={{
                        border: "2px solid rgb(203, 108, 230)",
                        borderRadius: "10px",
                        padding: "8px 12px",
                        backgroundColor: "rgb(255,255,255)",
                        // height: '44px'
                      }}
                    >
                      <input
                        className="w-100 login-input text-start"
                        type={showPassword ? "text" : "password"}
                        placeholder=""
                        style={{
                          background: "none",
                          outline: "none",
                          border: "none",
                          // width: '222.96px',
                          fontWeight: "400",
                          color: HEADER_COLOR,
                          letterSpacing: "0.01ch",
                          paddingInlineEnd: "22px",
                          fontSize: "13.5px",
                          // paddingInlineEnd: '30px'
                        }}
                        value={forgotPasswordOtp?.password}
                        onChange={(e) =>
                          setForgotPasswordOtp((prev) => {
                            return {
                              ...prev,
                              password: e.target.value,
                            };
                          })
                        }
                      />

                      <div
                        className="position-absolute d-flex align-items-center justify-content-center"
                        style={{
                          right: "9px",
                          top: "0",
                          height: "100%",
                        }}
                      >
                        {forgotPasswordOtp?.password !== "" &&
                          (!showPassword ? (
                            <HiEye
                              style={{
                                height: "20px",
                                width: "20px",
                                color: PRIMARY_COLOR,
                              }}
                              onClick={() => setShowPassword(true)}
                            />
                          ) : (
                            <HiEyeOff
                              style={{
                                height: "20px",
                                width: "20px",
                                color: PRIMARY_COLOR,
                              }}
                              onClick={() => setShowPassword(false)}
                            />
                          ))}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-12 p-0">
                  <div className="d-flex flex-column align-items-start justify-content-center">
                    <label
                      for="forgotPasswordEmail"
                      className="text-start form-label"
                      style={{
                        fontSize: "13.5px",
                        marginLeft: "4px",
                        marginBottom: "3px",
                        fontWeight: "500",
                        color: PRIMARY_COLOR,
                      }}
                    >
                      Confirm Password
                    </label>

                    <div
                      className="w-100 position-relative d-flex align-items-center"
                      style={{
                        border: "2px solid rgb(203, 108, 230)",
                        borderRadius: "10px",
                        padding: "8px 12px",
                        backgroundColor: "rgb(255,255,255)",
                        // height: '44px'
                      }}
                    >
                      <input
                        className="w-100 login-input text-start"
                        type={showConfirmPassword ? "text" : "password"}
                        placeholder=""
                        style={{
                          background: "none",
                          outline: "none",
                          border: "none",
                          // width: '222.96px',
                          fontWeight: "400",
                          color: HEADER_COLOR,
                          letterSpacing: "0.01ch",
                          paddingInlineEnd: "22px",
                          fontSize: "13.5px",
                          // paddingInlineEnd: '30px'
                        }}
                        value={forgotPasswordOtp?.confirmPassword}
                        onChange={(e) =>
                          setForgotPasswordOtp((prev) => {
                            return {
                              ...prev,
                              confirmPassword: e.target.value,
                            };
                          })
                        }
                      />

                      <div
                        className="position-absolute d-flex align-items-center justify-content-center"
                        style={{
                          right: "9px",
                          top: "0",
                          height: "100%",
                        }}
                      >
                        {forgotPasswordOtp?.confirmPassword !== "" &&
                          (!showConfirmPassword ? (
                            <HiEye
                              style={{
                                height: "20px",
                                width: "20px",
                                color: PRIMARY_COLOR,
                              }}
                              onClick={() => setShowConfirmPassword(true)}
                            />
                          ) : (
                            <HiEyeOff
                              style={{
                                height: "20px",
                                width: "20px",
                                color: PRIMARY_COLOR,
                              }}
                              onClick={() => setShowConfirmPassword(false)}
                            />
                          ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 p-0">
              <div
                className="row w-100 mx-auto flex-column align-items-center justfy-content-center"
                style={{
                  gap: "6px",
                  maxWidth: screenWidth >= 576 ? "310px" : "250px",
                }}
              >
                <div className="col-12 p-0">
                  <button
                    className="w-100 btn "
                    style={{
                      // backgroundColor: 'rgb(203, 108, 230)',
                      // color: '#fae5ff',
                      // width: '250px',
                      backgroundColor: "rgb(203, 108, 230)",
                      color: "#fae5ff",
                      borderRadius: "10px",
                      // height: '44px',
                      fontSize: "13.5px",
                      padding: "8.5px 12px",
                    }}
                    onClick={(e) => handleSubmit()}
                  >
                    Confirm
                  </button>
                </div>

                <div className="col-12 p-0">
                  <button
                    className="w-100 btn btn-light"
                    style={{
                      // width: '250px',
                      borderRadius: "10px",
                      // height: '44px',
                      fontSize: "13.5px",
                      padding: "8px 12px",
                    }}
                    onClick={(e) => navigate("/login")}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="col-12 p-0"
          style={
            {
              // marginTop: '35px'
            }
          }
        >
          <div
            className="row w-100 h-100 mx-auto align-items-center justify-content-center"
            style={{
              // minHeight: '15vh',
              padding: "0 0 20px 0",
            }}
          >
            <div className="col-auto p-0">
              <img
                className=""
                src={FooterLogo}
                alt="footer logo"
                style={{
                  width: "85px",
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordOTP;
